import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Dimmer, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {validateData, getParsedData} from './utils';
import ExcelReader from '../../../../excelReader/components/index';

class InvoiceFormButtons extends Component {
  constructor(props) {
    super(props);
    this.readExcelFile = this.readExcelFile.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
  }

  readExcelFile(data) {
    const {handleErrorState, hasToVerfyWeight} = this.props;
    const rowsWithErrors = validateData(data, hasToVerfyWeight);
    if (rowsWithErrors.length > 0) {
      this.props.loadingExcel(false);
      handleErrorState(rowsWithErrors);
      return;
    }

    handleErrorState([]);
    const dataParsed = getParsedData(data);
    this.props.saveExcelData(dataParsed);
    this.props.loadingExcel(false);
  }

  onCancelClick() {
    this.props.navigateBack();
  }

  clearForm() {
    const {reset, invoice, providerId, handleErrorState} = this.props;
    reset();
    handleErrorState([]);
    if (invoice && providerId) {
      this.props.fetchInvoiceData(invoice, providerId);
      return;
    }
    this.props.loadInitialData();
  }

  renderLoaders() {
    const {saving, cancelling} = this.props;

    if (saving) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Guardando' />
        </Dimmer>
      );
    } else if (cancelling) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Anulando' />
        </Dimmer>
      );
    }
  }

  renderEditButtons() {
    const {invoice, invoiceStatus, submitting, invalid, changeTypeOfSubmit} =
      this.props;
    const editingAllowedOfInvoice =
      !invoice || (invoice && invoiceStatus === 'I');

    if (editingAllowedOfInvoice) {
      return (
        <>
          <Button
            primary
            type='submit'
            disabled={submitting || invalid}
            onClick={() => changeTypeOfSubmit('save')}
          >
            Guardar
          </Button>
          <Button
            primary
            type='submit'
            disabled={submitting || invalid}
            onClick={() => changeTypeOfSubmit('send')}
          >
            Enviar
          </Button>
        </>
      );
    }
  }

  render() {
    const {
      submitting,
      saving,
      invalid,
      invoice,
      invoiceStatus,
      changeTypeOfSubmit,
    } = this.props;

    return (
      <div className='title-bar-actions'>
        {!invoice && (
          <ExcelReader onGetFile={this.readExcelFile} saving={saving} />
        )}
        {(!invoice && (!invoiceStatus || invoiceStatus === 'I')) && (
          <Button
            secondary
            type='button'
            onClick={this.clearForm}
            disabled={submitting}
          >
            Limpiar
          </Button>
        )}
        {(invoice && (!invoiceStatus || invoiceStatus === 'I')) && (
          <Button
            secondary
            type='button'
            onClick={this.onCancelClick}
            disabled={submitting}
          >
            Cancelar
          </Button>
        )}
        {invoice && (
          <Button
            primary
            type='submit'
            disabled={submitting || invalid}
            onClick={() => changeTypeOfSubmit('cancel')}
          >
            Anular
          </Button>
        )}
        {this.renderEditButtons()}
        {this.renderLoaders()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const systemParameters = state.parameters.list || [];
  const weightVerificationParameter =
     systemParameters.find((parameter) => parameter.code === 'WEIGHT_CHK') ||
     {};

  return {
    'saving': state.form.invoice.saving,
    'cancelling': state.form.invoice.cancelling,
    'loadingExcel': state.excelReader.loading,
    'hasToVerfyWeight': weightVerificationParameter.value ? true : false,
  };
};

const {
  navigateBack,
  loadInitialData,
  fetchInvoiceData,
  saveExcelData,
  loadingExcel,
} = Actions;

export default connect(mapStateToProps, {
  navigateBack,
  loadInitialData,
  fetchInvoiceData,
  saveExcelData,
  loadingExcel,
})(InvoiceFormButtons);
